import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { CONSTANT } from "src/app/constant";
import { OBAttempt } from "src/app/models/models";

@Component({
	selector: "app-ts1-role-ob-counter",
	templateUrl: "./ts1-role-ob-counter.component.html",
	styleUrls: ["./ts1-role-ob-counter.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1RoleObCounterComponent {
	@Input() control!: AbstractControl | null;
	@Input() maneuverAction: "create-form" | "edit-form" = "create-form";
	@Input() readonly = false;
	@Output() valueChange = new EventEmitter<OBAttempt>();

	readonly MAX = CONSTANT.MAX_OB_ATTEMPT_LIMIT;

	@HostBinding("class.ts1-role-ob-counter--conditional")
	get conditionalLockedClass(): boolean {
		return this.value.isConditional === true;
	}

	get value(): OBAttempt {
		return (this.control?.value ?? { totalCount: 0, currentCount: 0, preDefined: true, lastAction: "-" }) as OBAttempt;
	}

	add(): void {
		if (this.readonly || this.value.isConditional === true) return;
		const v = this.value;
		if (v.totalCount >= this.MAX) return;
		const next: OBAttempt = {
			...v,
			totalCount: v.totalCount + 1,
			currentCount: v.currentCount + 1,
			lastAction: this.maneuverAction === "edit-form" ? CONSTANT.OB_LAST_ACTION.EDIT : CONSTANT.OB_LAST_ACTION.CREATE,
		};
		this.control?.patchValue(next);
		this.valueChange.emit(next);
	}

	remove(): void {
		if (this.readonly || this.value.isConditional === true) return;
		const v = this.value;
		if (v.currentCount <= 0) return;
		const next: OBAttempt = {
			...v,
			currentCount: v.currentCount - 1,
			totalCount: v.totalCount - 1,
			lastAction: CONSTANT.OB_LAST_ACTION.REMOVED,
		};
		this.control?.patchValue(next);
		this.valueChange.emit(next);
	}

	get disableRemove(): boolean {
		return this.readonly || this.value.isConditional === true || this.value.currentCount <= 0;
	}

	get disableAdd(): boolean {
		return this.readonly || this.value.isConditional === true || this.value.totalCount >= this.MAX;
	}
}
